export const iconFontAwesomeMedicalHealthHeadSideCough = (
	<i className="fa-solid fa-head-side-cough"></i>
);
